// @ts-nocheck
import buildFields from "@store/Framework/Features/FieldDefinitionBuilder/Builders/buildFields";
import { buildResponsiveFields } from "@store/Framework/Features/FieldDefinitionBuilder/Builders/buildResponsiveFields";
import { FieldDefinitionsBuilderOptions } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import imageFieldDictionary from "@store/Framework/Features/FieldDefinitionBuilder/Fields/imageFieldDictionary";
import typographyFieldDictionary from "@store/Framework/Features/FieldDefinitionBuilder/Fields/typographyFieldDictionary";
import toChildFieldDefinition from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/toChildFieldDefinition";
import withTab from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/withTab";
import { GreifFieldDefinition } from "@store/Framework/Types/FieldDefinition";

const resolveOptionsFields = (options?: FieldDefinitionsBuilderOptions) => {
    const basicFields: GreifFieldDefinition[] = [];
    const responsiveFields: GreifFieldDefinition[] = [];

    const typographyFieldDefinitions = buildFields(typographyFieldDictionary, options?.typographyOptions);
    const imageFieldDefinitions = buildFields(imageFieldDictionary, options?.imageOptions);
    const optionsFields = [...typographyFieldDefinitions, ...imageFieldDefinitions];

    optionsFields.forEach(x => {
        for (const key in options) {
            const option = (options as any)[key];

            if (option[x.name]) {
                if (option[x.name]?.hasResponsive) {
                    responsiveFields.push(x);
                    break;
                } else {
                    basicFields.push(x);
                    break;
                }
            }
        }
    });

    return {
        basicFields,
        responsiveFields,
    };
};

export default (
    fieldDefinitions: GreifFieldDefinition[],
    options?: FieldDefinitionsBuilderOptions,
): GreifFieldDefinition[] => {
    const basicTab = {
        displayName: "Basic",
        sortOrder: 0,
    };

    const responsiveTab = {
        displayName: "Responsive",
        sortOrder: 1,
    };

    const baseFieldDefinitions = [...(fieldDefinitions || [])];

    const buildFieldDefinitions = (): GreifFieldDefinition[] => {
        const { basicFields, responsiveFields } = resolveOptionsFields(options);

        const fields = [
            ...withTab(basicTab, [...basicFields]),
            ...(responsiveFields.length || baseFieldDefinitions.length
                ? withTab(responsiveTab, [
                      ...baseFieldDefinitions,
                      ...responsiveFields,
                      ...buildResponsiveFields([
                          ...toChildFieldDefinition(baseFieldDefinitions),
                          ...toChildFieldDefinition(responsiveFields),
                      ]),
                  ])
                : []),
        ];

        return fields;
    };

    return buildFieldDefinitions();
};
